import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect } from "react";
import {
  Redirect,
  Route,
  BrowserRouter as Router,
  Switch,
} from "react-router-dom";
import "./App.css";
import Lose from "./views/End/Lose/Lose";
import Win from "./views/End/Win/Win";
import Game from "./views/Game/Game";
import MainMenu from "./views/MainMenu/MainMenu";

function App() {
  useEffect(() => {
    if (window.location.pathname !== "/") window.location.href = "/";
  }, []);

  return (
    <>
      <Router>
        <Switch>
          <Route exact path="/" component={MainMenu} />
          <Route exact path="/play" component={Game} />
          <Route exact path="/end/win" component={Win} />
          <Route exact path="/end/lose" component={Lose} />
          <Redirect to="/" />
        </Switch>
      </Router>
    </>
  );
}

export default App;
